import { z } from 'zod';
import type { TFunction } from 'i18next';

const TITLE_MAX_LENGTH = 255;

/**
 * Edit-brief form schema. Currently a single `title` field (rename only); the
 * `edit-brief` naming leaves room to add tags / other editable fields later
 * without renaming the slice.
 *
 * A factory, not a module-scope const: building the schema at import time would bake
 * in whatever language was active then, and the messages could never follow a change.
 */
export const buildEditBriefFormSchema = (t: TFunction<'validation'>) =>
  z.object({
    title: z
      .string()
      .trim()
      .min(1, t('editBrief.editBriefModal.briefNameIsRequired'))
      .max(TITLE_MAX_LENGTH, t('editBrief.editBriefModal.nameIsTooLong')),
  });

export type EditBriefFormData = z.infer<ReturnType<typeof buildEditBriefFormSchema>>;
